import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-print-filters',
	templateUrl: './print-filters.component.html',
	styleUrls: ['./print-filters.component.css']
})
export class PrintFiltersComponent {

	// Most pages keep their section heading outside the printSectionId container, so it
	// never reaches the printout - passing it here is what puts the chart name on the page.
	@Input() title = '';
	@Input() filters: { label: string, value: string }[] = [];
}
